/* @jsx h */
import { defineComponent, h } from "vue";
import type { GiftCardHolder } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";
import { GiftCardSection } from "./Section";

export type GiftCardHolderFieldsProps = {
  value: GiftCardHolder;
  onChange: (value: GiftCardHolder) => void;
};

/**
 * Who a plain gift card is sold to. Optional; stored on the card and printed
 * on the receipt.
 */
export const GiftCardHolderFields = defineComponent<GiftCardHolderFieldsProps>(
  {
    name: "GiftCardHolderFields",
    props: ["value", "onChange"],
    setup(props) {
      const { t } = useLocalization();

      const field = (
        key: keyof GiftCardHolder,
        label: string,
        type: string,
        autocomplete: string,
      ) => (
        <label class="form-control">
          <span class="label-text text-xs text-base-content/60">{label}</span>
          <input
            type={type}
            autocomplete={autocomplete}
            class="input input-bordered input-sm md:input-md"
            value={props.value[key] ?? ""}
            onInput={(e: Event) =>
              props.onChange({
                ...props.value,
                [key]: (e.target as HTMLInputElement).value,
              })
            }
          />
        </label>
      );

      return () => (
        <GiftCardSection icon="person" title={t("pos.gift_card.holder")}>
          <div class="grid grid-cols-1 gap-2 sm:grid-cols-3">
            {field("name", t("pos.gift_card.holder_name"), "text", "name")}
            {field("email", t("pos.gift_card.holder_email"), "email", "email")}
            {field("phone", t("pos.gift_card.holder_phone"), "tel", "tel")}
          </div>
        </GiftCardSection>
      );
    },
  },
);
